<template>
    <div class="container-fluid">
         <!-- Search Bar -->
        <div class="search-bar-form row m-0">
            <form class="" method="" id="">
                <!-- Search Bar Form -->
                <input type="search" class="search-bar-form__input form-control" name="search" placeholder="Busca un producto aquí" v-model="search">
                
                <!-- Search Bar Dropdown -->
                <div class="search-bar-dropdown">
                    <div class="search-bar-dropdown__categories content-input">
                        <input type="hidden" name="categories" value="Categorias">
                        <select class="form-control search-bar-dropdown__select" id="">
                            <option value="price-ascending">Todas las categorias</option>
                            <option value="price-descending">Precio - Alto a Bajo</option>
                            <option value="best-selling">Más vendidos</option>
                            <option value="title-ascending">Alfabéticos, A-Z</option>
                            <option value="title-descending">Alfabéticos, Z-A</option>
                            <option value="created-ascending">Lo más Nuevo</option>
                            <option value="created-descending">Menos Nuevo</option>
                        </select>
                    </div>
                </div>

                <!-- Search Bar Button -->
                <div class="search-bar-form__button base-button accept-btn">BUSCAR</div>
            </form>
        </div>
    </div>
</template>

<script>

import vue from 'vue'
import router from 'vue-router'

vue.use(router)

export default {
    name:'SearchCategories',
    referTo: '/search-categories'
}
</script>

<style lang="css" scoped>
img {
    max-width: 100%;
}
h1 {
    font-size: 26px;
}
.mr-20 {
    margin-right: 20px;
}

a {
    color:#213F99;
}
a:hover {
    text-decoration: underline;
    color:#213F99;
}
.padding--section {
    padding: 25px 0;
}
.border-line {
    border: 1px solid #e7e7e7;
}
/* Button */
.base-button {
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 40px;
    text-transform: uppercase;
    font-weight: 800;
    font-size: 14px;
    letter-spacing: 1px;
    cursor: pointer;
    text-align: center;
    word-break: keep-all;
    transition: all .3s;
}
    
.accept-btn {
    background-color: #38b449;
    color: #fff;
}
.accept-btn:hover {
    background-color: #1e2d7d;
}

.home-offer__content {
    padding-bottom: 50px;
}

.home-offer__sliders,
.search-bar-form {
    display: flex;    
}

.search-bar-form {
    margin-bottom: 20px;
    margin-top: 40px;
}

.search-bar-form form {
    width: 100%;
}
.search-bar-form__input {
    width: 65%;
    float: left;
}
.search-bar-dropdown {
    width: 23%;
    float: left; 
}
.search-bar-form__button {
    width: 10%;
    height: 42px;
    float: right;
}
</style>


// WEBPACK FOOTER //
// search-categories.vue?5b4c5574